import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import {
  component as componentNoEarlyNoReverb,
  extraContent as extraContentNoEarlyNoReverb,
} from "./components/no-early-no-reverb";
import {
  component as componentNoEarlyNormalReverb,
  extraContent as extraContentNoEarlyNormalReverb,
} from "./components/no-early-normal-reverb";
import {
  component as componentNoEarlyStrongReverb,
  extraContent as extraContentNoEarlyStrongReverb,
} from "./components/no-early-strong-reverb";
import {
  component as componentNoEarlyWeakReverb,
  extraContent as extraContentNoEarlyWeakReverb,
} from "./components/no-early-weak-reverb";
import {
  component as componentNormalEarlyNoReverb,
  extraContent as extraContentNormalEarlyNoReverb,
} from "./components/normal-early-no-reverb";
import {
  component as componentNormalEarlyNormalReverb,
  extraContent as extraContentNormalEarlyNormalReverb,
} from "./components/normal-early-normal-reverb";
import {
  component as componentNormalEarlyStrongReverb,
  extraContent as extraContentNormalEarlyStrongReverb,
} from "./components/normal-early-strong-reverb";
import {
  component as componentNormalEarlyWeakReverb,
  extraContent as extraContentNormalEarlyWeakReverb,
} from "./components/normal-early-weak-reverb";
import {
  component as componentStrongEarlyNoReverb,
  extraContent as extraContentStrongEarlyNoReverb,
} from "./components/strong-early-no-reverb";
import {
  component as componentStrongEarlyNormalReverb,
  extraContent as extraContentStrongEarlyNormalReverb,
} from "./components/strong-early-normal-reverb";
import {
  component as componentStrongEarlyStrongReverb,
  extraContent as extraContentStrongEarlyStrongReverb,
} from "./components/strong-early-strong-reverb";
import {
  component as componentStrongEarlyWeakReverb,
  extraContent as extraContentStrongEarlyWeakReverb,
} from "./components/strong-early-weak-reverb";

const principle: Slide = {
  title: "",
  description:
    "Create a room impulse response (RIR) by choosing different level settings for the early and late parts of the impulse response. See how the objective parameters change and evaluate subjectively what this sounds like for an excerpt of a Bruckner symphony.  The direct sound is always present and corresponds to a 10m source-receiver distance. The reverberation has a constant RT of 1.9s (at mid-frequencies), only the level of the reverberation changes.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          items: [
            {
              name: "1 - no early reflections",
            },
            {
              name: "2 - normal level early reflections",
            },
            {
              name: "3 - strong early reflections",
            },
          ],
          options: {
            label: "Early part of impulse response:",
          },
        },
        {
          type: "dropdown",
          items: [
            {
              name: "1 - no reverberation",
            },
            {
              name: "2 - weak reverberation",
            },
            {
              name: "3 - normal level reverberation",
            },
            {
              name: "4 - strong reverberation",
            },
          ],
          options: {
            label: "Late part of impulse response:",
          },
        },
      ],
      extraContent: [
        [
          extraContentNoEarlyNoReverb,
          extraContentNoEarlyWeakReverb,
          extraContentNoEarlyNormalReverb,
          extraContentNoEarlyStrongReverb,
        ],
        [
          extraContentNormalEarlyNoReverb,
          extraContentNormalEarlyWeakReverb,
          extraContentNormalEarlyNormalReverb,
          extraContentNormalEarlyStrongReverb,
        ],
        [
          extraContentStrongEarlyNoReverb,
          extraContentStrongEarlyWeakReverb,
          extraContentStrongEarlyNormalReverb,
          extraContentStrongEarlyStrongReverb,
        ],
      ],
      components: [
        [
          componentNoEarlyNoReverb,
          componentNoEarlyWeakReverb,
          componentNoEarlyNormalReverb,
          componentNoEarlyStrongReverb,
        ],
        [
          componentNormalEarlyNoReverb,
          componentNormalEarlyWeakReverb,
          componentNormalEarlyNormalReverb,
          componentNormalEarlyStrongReverb,
        ],
        [
          componentStrongEarlyNoReverb,
          componentStrongEarlyWeakReverb,
          componentStrongEarlyNormalReverb,
          componentStrongEarlyStrongReverb,
        ],
      ],
    },
  },
};

export default principle;
